export const WRIST_EXERCISES = [
  {
    time: 12.0,
    text: "Straighten your arms in front of you with your palms pointing forward",
  },
  {
    time: 12.0,
    text: "Hold your LEFT fingers with your RIGHT hand.",
  },
  {
    time: 12.0,
    text: "Gently bend your LEFT wrist back until you feel a stretch in your forearm.",
  },
  {
    time: 30.0,
    text: "Hold this position. If this hurts, apply less pressure.",
  },
  { time: 3.0, text: "Gently relax" },
  {
    time: 12.0,
    text: "With your palms pointing up, hold your LEFT fingers with your RIGHT hand.",
  },
  {
    time: 12.0,
    text: "Gently bend your LEFT wrist back until you feel a stretch in your forearm.",
  },
  { time: 30.0, text: "Hold this position." },
  { time: 6.0, text: "Gently relax" },
  {
    time: 3.0,
    text: "Now for the right arm!",
  },
  {
    time: 12.0,
    text: "With your palms pointing forward, hold your RIGHT fingers with your LEFT hand and pull back.",
  },
  { time: 30.0, text: "Hold this position." },
  { time: 3.0, text: "Gently relax" },
  {
    time: 12.0,
    text: "With your palms pointing up, hold your RIGHT fingers with your LEFT hand and pull back.",
  },
  { time: 30.0, text: "Hold this position." },
  { time: 3.0, text: "Gently relax and you're done!" },
];
